export default __webpack_public_path__ + "static/media/training-highlight.62854d4e.svg";